import { render, staticRenderFns } from "./UpdateAdminForm.vue?vue&type=template&id=011fb9ec&"
import script from "./UpdateAdminForm.vue?vue&type=script&lang=js&"
export * from "./UpdateAdminForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports